import { Outlet } from "react-router-dom";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { PageContainer } from "@toolpad/core/PageContainer";

export default function Layout() {
  return (
    <DashboardLayout sidebarExpandedWidth={320}>
      <PageContainer
        maxWidth={false}
        breadcrumbs={[{ path: "", title: "" }]}
        title=""
      >
        <Outlet />
      </PageContainer>
    </DashboardLayout>
  );
}
